import * as yup from 'yup';

export const schemaMail = yup.object().shape({
  host: yup.string().required('O Host é obrigatório'),
  port: yup.number().required('A Porta é obrigatória'),
  service: yup.string().required('O Serviço é obrigatório'),
  user: yup.string().required('O Email é obrigatório'),
  password: yup.string().required('A Senha é obrigatório'),
});
